/**
 * Main
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */

document.addEventListener( 'DOMContentLoaded', () => {
	let $window = $( window );

	if ( window.location.hash ) {
		scroll( 0, 0 );
	}

	if ( location.hash ) {
		scrollPageTo( location.hash );
	}

	function headerScroll() {
		let $header = $( '.header' );

		if ( $window.scrollTop() > 50 ) {
			if ( !$header.hasClass( 'header--fixed' ) ) {
				$header.addClass( 'header--fixed' );
			}
		} else {
			$header.removeClass( 'header--fixed' );
		}
	}

	headerScroll();

	$window.scroll( function() {
		headerScroll();
	} );

	$( '.help' ).click( function() {
		$( this ).toggleClass( 'is-active' );
	} );

	$( '.js-smooth-scroll' ).click( function( event ) {
		if ( location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
			let target = $( this.hash );

			target = target.length ? target : $( `[name=${this.hash.slice( 1 )}]` );
			if ( target.length ) {
				event.preventDefault();
				$( 'html, body' ).animate( {
					scrollTop: target.offset().top - 100,
				}, 750 );
			}
		}
	} );

	$( '.header__nav > ul > li.menu-item-has-children' ).append( '<span></span>' );

	$( '.header__nav > ul > li.menu-item-has-children > span' ).click( function( e ) {
		e.preventDefault();
		if ( !$( this ).parent().hasClass( 'is-active' ) ) {
			$( '.header__nav > ul > li.menu-item-has-children' ).removeClass( 'is-active' );
			$( this ).parent().addClass( 'is-active' );
		} else {
			$( this ).parent().removeClass( 'is-active' );
		}
	} );

	$( '.header__toggle' ).click( function( e ) {
		e.preventDefault();
		$( 'html' ).toggleClass( 'is-open-menu' );
	} );
} );
